import { getResultTypeOptions } from "../results/registry";

/**
 * French singular alias shown/typed for each (English, plural) Meilisearch
 * index name — so `type:contact` and `type:client` work in the DSL.
 */
const TYPE_ALIAS_SUGGESTIONS: { alias: string; value: string }[] = [
  { alias: "contact", value: "contacts" },
  { alias: "client", value: "clients" },
  { alias: "employé", value: "employees" },
  { alias: "projet", value: "projects" },
  { alias: "lieu", value: "locations" },
  { alias: "fournisseur", value: "suppliers" },
  { alias: "sous-traitant", value: "subcontractors" },
  { alias: "adresse", value: "addresses" },
];

// Extra typable variants that shouldn't clutter the suggestion list.
const EXTRA_ALIASES: Record<string, string> = {
  employe: "employees",
};

const TYPE_ALIASES: Record<string, string> = {
  ...Object.fromEntries(
    TYPE_ALIAS_SUGGESTIONS.map(({ alias, value }) => [alias, value]),
  ),
  ...EXTRA_ALIASES,
};

export function getTypeAliasSuggestions(): { alias: string; value: string }[] {
  return TYPE_ALIAS_SUGGESTIONS;
}

export function resolveTypeAlias(word: string): string | null {
  const normalized = word.trim().toLowerCase();

  const validTypes = getResultTypeOptions().map((option) => option.value);

  if (validTypes.includes(normalized)) {
    return normalized;
  }

  return TYPE_ALIASES[normalized] ?? null;
}
